/**
 * Set up routing for all Location views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import location views
import AdminCreateSiteLocation from './views/AdminCreateSiteLocation.js.jsx';
import AdminSiteLocationList from './views/AdminSiteLocationList.js.jsx';
import AdminSingleSiteLocation from './views/AdminSingleSiteLocation.js.jsx';
import AdminUpdateSiteLocation from './views/AdminUpdateSiteLocation.js.jsx';

class SiteLocationAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleSiteLocationUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display:'All locations', path:null}]}
          component={AdminSiteLocationList}
          exact
          path="/admin/site-locations"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display:'All locations', path:'/admin/site-locations'}, {display: 'New location', path: null}]}
          component={AdminCreateSiteLocation}
          exact
          path="/admin/site-locations/new"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display:'All locations', path:'/admin/site-locations'}, {display: 'Location details', path:null}]}
          component={AdminSingleSiteLocation}
          exact
          path="/admin/site-locations/:siteLocationId"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display:'All locations', path:'/admin/site-locations'}, {display: 'Location details', path: singleSiteLocationUpdatePath}, {display:'Update', path:null}]}
          component={AdminUpdateSiteLocation}
          exact
          path="/admin/site-locations/:siteLocationId/update"
          role="admin"
        />
      </Switch>
    )
  }
}

export default withRouter(SiteLocationAdminRouter);



// WEBPACK FOOTER //
// modules/siteLocation/SiteLocationAdminRouter.js.jsx